import { io } from 'socket.io-client';

let socket = null;

export const getSocket = () => {
  if (!socket) {
    socket = io(process.env.REACT_APP_SOCKET_URL || '', {
      // Funksion: token-i lexohet fresh në çdo (ri)lidhje. Admin = zq_token; garues = ilmify_pt (pas PIN-it).
      auth: (cb) => cb({ token: localStorage.getItem('zq_token') || sessionStorage.getItem('ilmify_pt') || null }),
      autoConnect: false,
    });
  }
  return socket;
};

export const connectSocket = () => {
  const s = getSocket();
  if (!s.connected) s.connect();
  return s;
};

export const disconnectSocket = () => {
  if (socket?.connected) socket.disconnect();
};
